import { api as languagesApi } from './auto-generated/languages'

languagesApi.enhanceEndpoints({
  endpoints: {},
})

export { languagesApi }
